import { useState } from 'react'
import { Cake, Heart } from 'lucide-react'
import type { OccasionKind } from '@familynest/shared'
import { OccasionsScreen } from './OccasionsScreen'

const TABS: Array<{ k: OccasionKind; label: string; icon: typeof Cake }> = [
  { k: 'birthday', label: 'Geburtstage', icon: Cake },
  { k: 'anniversary', label: 'Jahrestage', icon: Heart },
]

/**
 * „Anlässe" (ADR-036): fasst Geburtstage und Jahrestage — technisch dieselbe
 * Ansicht (OccasionsScreen mit `kind`) — unter einem Navigationseintrag mit
 * Segmented-Control zusammen. Spart auf schmalen Handys einen Menüpunkt.
 */
export function OccasionsTab(): React.JSX.Element {
  const [kind, setKind] = useState<OccasionKind>('birthday')
  return (
    <div className="min-h-full">
      <div
        className="sticky top-0 z-10 flex gap-1 border-b p-2"
        style={{ borderColor: 'var(--color-line)', backgroundColor: 'var(--color-card)' }}
      >
        {TABS.map(({ k, label, icon: Icon }) => (
          <button
            key={k}
            onClick={() => setKind(k)}
            className="flex flex-1 items-center justify-center gap-1.5 rounded-lg px-3 py-1.5 text-sm font-medium"
            style={kind === k ? { backgroundColor: 'var(--color-accent)', color: '#fff' } : { color: 'var(--color-muted)' }}
          >
            <Icon className="size-4" /> {label}
          </button>
        ))}
      </div>
      <OccasionsScreen kind={kind} />
    </div>
  )
}
